import { Card, Tabs } from 'antd'
import { useState } from 'react'
import PreeventHandson from './PreeventHandson'
import PreeventViewer from './PreeventViewer'
import PreeventRecording from './PreeventRecording'
import PreeventRemind from './PreeventRemind'
import { EmailTemplateButton } from './EmailTemplateButton'

const tabItems = [
  {
    key: 'Hands-on',
    label: 'Hands-on',
    children: <PreeventHandson />
  },
  {
    key: 'Viewer',
    label: 'Viewer',
    children: <PreeventViewer />
  },
  {
    key: 'Recording',
    label: 'Recording',
    children: <PreeventRecording />
  }
]

const PreEvent = function () {
  const [selectedTab, setSelectedTab] = useState('Hands-on')

  return (
    <Card>
      <PreeventRemind />
      <EmailTemplateButton
        type='Waitlist'
        title='Waitlist confirmation'
        settingKey='waitlist.confirmation'
      />
      <Tabs
        activeKey={selectedTab}
        items={tabItems}
        onChange={(t) => {
          setSelectedTab(t)
        }}
      />
    </Card>
  )
}

export default PreEvent
